import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { usePageTitle } from '../../hooks/usePageTitle';

const Settings: React.FC = () => {
  usePageTitle('Settings | From the Pitchside');

  const { user } = useAuthContext();

  return (
    <div className="text-darkblue">
        <h2>Settings</h2>
    </div>
  );
};

export default Settings;
